/**
 * 空のプロパティ公開
 */
export type EmptyPropsPub = Record<string, never>

/**
 * 空のJSON公開
 */
export type EmptyJsonPub = Record<string, never>

/**
 * 空の公開
 */
export type EntityPubType<JP> = {
  /** 送信者ID */
  sendId: string,
  /** 送信先ID */
  replyId: string,
  /** データ */
  data: JP,
} | null

/**
 * 空のデータ公開
 */
export type EntityDataPubType<J, JP> = {
  /** データ */
  data: J,
  /** PUB */
  pub: EntityPubType<JP>,
}

/**
 * Entityの抽象クラス.
 */
export abstract class EntityBase<P, J, PP, JP> {
  /**
   * Entityを生成します.
   * 必ずFactoryから生成してください.
   * @param _value 値.
   */
  constructor(_value: P, _valuePub: EntityPubType<PP>) {
    this._value = Object.freeze(_value);
    this._valuePub = Object.freeze(_valuePub);
  }

  /** JSONデータ取得 */
  abstract toJsonData(): J

  /** JSON pub取得 */
  abstract toJsonPub(): EntityPubType<JP>

  /** Entityキー */
  abstract get entityKey(): string;

  /**
   * EntityをJsonに変換します.
   */
  toJson(): EntityDataPubType<J, JP> {
    return {
      /** データ */
      data: this.toJsonData(),
      /** Pub */
      pub: this.toJsonPub(),
    };
  }

  /** サブキー */
  get subKey(): string | null {
    return null;
  }

  /** サブキー2 */
  get subKey2(): string | null {
    return null;
  }

  /** GSIキー */
  get gsiKey(): string | null {
    return null;
  }

  /** データ */
  get data(): string {
    return JSON.stringify(this.toJsonData());
  }

  /** PUB */
  get pub(): EntityPubType<string> {
    const p = this.toJsonPub();
    if (p) {
      return {
        sendId: p.sendId,
        replyId: p.replyId,
        data: JSON.stringify(p.data),
      };
    }
    return null;
  }

  /**
   * EntityのID.
   */
  get id(): string {
    return this.entityKey;
  }

  /**
   * Entityが同一かどうかを判定します.
   * @param entity 比較Entity
   * @returns 同一かどうか
   */
  isEqual(entity: EntityBase<P, J, PP, JP>): boolean {
    return entity.id === this.id;
  }

  /**
   * Entityの値.
   */
  protected readonly _value: P;

  /**
   * 値pub
   */
  protected readonly _valuePub: EntityPubType<PP>;
}
